import { Field, HelpTooltip } from '~/components';
import React from 'react';
import styled from 'styled-components';

const Control = styled.div`
  display: flex;
  align-items: center;
`;

export default function CapMonthlyAssignedHoursCheckbox({ useRoles }) {
  return (
    <Control>
      <Field.Checkbox
        name="capMonthlyAssignedHours"
        label={`Cap the monthly hours by ${useRoles ? 'role' : 'member'}`}
      />

      <HelpTooltip
        message={`Do not allow a time entry to be saved if it will cause the project to exceed its monthly ${useRoles ? 'role' : 'member'} hours budget.`}
        style={{ marginLeft: '.5rem' }}
      />
    </Control>
  );
}
